// extracted by mini-css-extract-plugin
export var emptyState = "_4w-d";
export var statCard = "_4w-c";
export var table = "_4w-0";
export var tableCell = "_4w-4";
export var tableCellClickable = "_4w-5 _4w-4";
export var tableCellDefault = "_4w-6 _4w-4";
export var tableCellEmpty = "_4w-8";
export var tableCellWithValue = "_4w-7";
export var tableContainer = "_4w-e";
export var tableHeaderWeight = "_4w-1";
export var tableHeaderZone = "_4w-2";
export var tableRowHeader = "_4w-3";
export var viewModeButton = "_4w-9";
export var viewModeButtonActive = "_4w-a _4w-9";
export var viewModeButtonInactive = "_4w-b _4w-9";